module.exports = __webpack_public_path__ + "img/promovemos.20435c1b.png";